export default __webpack_public_path__ + "images/xdai_85a2da.svg";